import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MadeToOrderFabric} from 'src/app/product-details/interface/made-to-order-fabric';
import {CurrencyResolverService} from "../../../../currency-resolver.service";
import {ApCurrency} from "../../../../pipe/enum/ap-currency";

@Component({
  selector: 'fb-choose-mto-fabric-more-option-info',
  templateUrl: './choose-mto-fabric-more-option-info.component.html',
  styleUrls: ['./choose-mto-fabric-more-option-info.component.scss']
})
export class ChooseMtoFabricMoreOptionInfoComponent implements OnInit {
	@Input() chooseMTOFabricPopupData: MadeToOrderFabric = {} as MadeToOrderFabric;
	@Output() closeMTOFabricOption: EventEmitter<any> = new EventEmitter();
	public selectedCurrency: ApCurrency = ApCurrency.USD;

	constructor(
		private _currencyResolver: CurrencyResolverService
	) {

	}
	public closeInfo(): void {
		this.closeMTOFabricOption.emit(false);
	}

	public ngOnInit(): void {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(()=> {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});
	}
}
